import accountReducer from './account';
import commonReducer from './common';
import toolsReducer from './tools';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

const rootReducer = combineReducers({
  account: accountReducer,
  common: commonReducer,
  tools: toolsReducer,
  form: formReducer
});

export default rootReducer;
